import { Box, Paper } from "@mui/material"
import { ReactNode } from "react"

interface AdminCardProps {
  icon: ReactNode
  name: string
  description: string
  disabled?: boolean
}

function AdministrationCard(props: AdminCardProps) {
  return (
    <Paper className={"admin-grid-item-paper"}>
      <Box
        sx={{ opacity: props.disabled ? 0.5 : 1, pointerEvents: props.disabled ? "none" : "auto" }}
        className={"admin-grid-item-paper-container"}
      >
        <Box className={"admin-grid-item-paper-icon-container"}>{props.icon}</Box>
        <Box className={"admin-grid-item-paper-name"}>{props.name}</Box>
        <Box className={"admin-grid-item-paper-description"}>{props.description}</Box>
      </Box>
    </Paper>
  )
}

export default AdministrationCard
